import React, { useContext } from "react";
import GenericTree from "../GenericTree";
import { labels } from "../../../localization/labels";
import { Input, Divider, List } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinusCircle, faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import styled from "styled-components";
import SecurityUtils from "../../../utils/SecurityUtils";
import { Button, Row, Col } from "react-bootstrap";
import { AppContext } from "../../domain/App/AppContext";
import SubmitControl from "../SubmitControl/SubmitControl";

const { Search } = Input;

const ModalContainer = styled.div`
  pointer-events: ${props => (props.inProgress ? "none" : "auto")};
`;

const ModalTreeInput = props => {
  const enabled = SecurityUtils.userHasAnyOfProcessesOrSameParty(
    props.processes,
    props.partyId
  );
  const createItems = item => {
    const removable = props.classificationsFilter
      ? props.classificationsFilter.includes(String(item.id))
      : true;
    const removeIcon = removable ? (
      <Button id={item.id} variant="link" onClick={props.removeItem}>
        <FontAwesomeIcon color="red" icon={faMinusCircle} />
      </Button>
    ) : null;
    return (
      <List.Item
        key={"item_" + item.id}
        style={{ marginLeft: 10 }}
        actions={[enabled && !props.readOnly ? removeIcon : null]}
      >
        {item.name}
      </List.Item>
    );
  };

  const inProgress = useContext(AppContext).promiseInProgress;

  return (
    <Row>
      <Col>
        <ModalContainer inProgress={inProgress}>
          {!props.readOnly
            ? SecurityUtils.renderElementByPermissions(
                <>
                  <div className="tree-modal">
                    <Divider orientation="left">{props.treeTitle}:</Divider>

                    {props.searchable ? (
                      <SubmitControl
                        disableable={false}
                        style={{ marginBottom: 8 }}
                        type="search"
                        placeholder={labels.search}
                        onChange={props.onSearchChange}
                        value={props.searchValue}
                      />
                    ) : null}
                    <GenericTree
                      ref={props.treeRef}
                      data={props.data}
                      loadedKeys={props.loadedKeys}
                      loadData={props.loadData}
                      draggable={false}
                      onClick={props.onClick}
                      pageInfo={props.pageInfo}
                      onPageNumberClick={props.onPageNumberClick}
                      fontAwesomeIcon={faPlusCircle}
                    />
                  </div>
                </>,
                props.processes,
                props.partyId
              )
            : null}
          <div className="selected-list-modal">
            <Divider orientation="left">{props.listTitle}:</Divider>
            <List
              dataSource={props.selectedData}
              renderItem={createItems}
              locale={{ emptyText: labels.noData }}
            ></List>
          </div>
        </ModalContainer>
      </Col>
    </Row>
  );
};

export default ModalTreeInput;
